import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';
import { useFormikContext } from 'formik';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { LojaConfiguracao, LojaRequest } from 'pages/cadastro/loja/types';
import { getInitialValue } from 'pages/cadastro/loja/utils';

export function useQueryConfiguracaoPropriedade() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();
    const { setFieldValue } = useFormikContext<LojaRequest>();

    return useQuery(
        ['lojaConfiguracaoPropriedade'],
        () =>
            requestListagem({
                url: '/gestao/configuracaopropriedade',
                sort: [{ property: 'idConfiguracaoPropriedade', direction: 'ASC' }],
                columns: 'idConfiguracaoPropriedade,dsConfiguracao,dsChave',
                limit: 20,
            }).then((res) => res.data.data),
        {
            enabled: !id,
            onSuccess: (value: LojaConfiguracao[]) => {
                const lojaConfiguracoes = value.map((item: LojaConfiguracao) => ({
                    ...item,
                    dsValor: getInitialValue(item.dsChave),

                    configuracaoPropriedade: {
                        dsChave: item.dsChave,
                        dsConfiguracao: item.dsConfiguracao,
                        idConfiguracaoPropriedade: item.idConfiguracaoPropriedade,
                    },
                }));

                setFieldValue('lojaConfiguracoes', lojaConfiguracoes);
            },
        },
    );
}
